/**
 * String Formatting Utilities
 *
 * Shared text formatting helpers used across backend and frontend services.
 */

/**
 * Convert a snake_case string to Title Case.
 *
 * @example snakeToTitleCase('business_admin') → 'Business Admin'
 * @example snakeToTitleCase('in_progress') → 'In Progress'
 */
export function snakeToTitleCase(text: string | null | undefined): string {
  if (!text) return '';
  return text
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
